import React from "react";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <main id="main" className="min-h-[70vh] flex items-center">
      <Seo path="" title="Stránka nenalezena | Vinařství Brychta" description="Požadovaná stránka nebyla nalezena." noindex />
      <div className="max-w-2xl mx-auto text-center px-5 py-24">
        <div className="text-[11px] tracking-[.28em] uppercase text-burgundy">Chyba 404</div>
        <h1 className="mt-4 font-serif font-light text-5xl md:text-6xl">Stránka nenalezena</h1>
        <p className="mt-6 text-charcoal/75 leading-relaxed">
          Zdá se, že tato adresa nikam nevede. Vraťte se na úvodní stránku
          nebo si rovnou vyberte zážitek či ubytování.
        </p>
        <div className="mt-8 flex gap-3 justify-center flex-wrap">
          <Link to="/" className="bg-burgundy hover:bg-burgundy-hover text-ivory px-7 py-3.5 tracking-wide">Zpět na úvod</Link>
          <Link to="/zazitky" className="border border-charcoal/25 text-charcoal hover:bg-cream px-7 py-3.5 tracking-wide">Zážitky</Link>
        </div>
      </div>
    </main>
  );
}
